import { VuexModule, Mutation, getModule } from 'vuex-module-decorators'
import DynamicModule from '@/decorators/DynamicModule'

@DynamicModule
class LayoutStore extends VuexModule {
  rightSidebarComponent: Function | null = null
  isShowLeftSidebar = true

  @Mutation
  public setRightSidebarComponent(component: Function | null) {
    this.rightSidebarComponent = component

    if (component !== null) {
      this.isShowLeftSidebar = false
    }
  }

  @Mutation
  public toggleLeftSidebar(force: boolean) {
    this.isShowLeftSidebar = force

    if (this.isShowLeftSidebar) {
      this.rightSidebarComponent = null
    }
  }
}

export default getModule(LayoutStore)
